export default __webpack_public_path__ + "static/media/error.9cfb79b8.svg";